var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"opacity":"0.8","z-index":"300","value":_vm.loading || _vm.isLoading}},[_c('div',{staticClass:"pulse"},[_c('img',{attrs:{"src":"/static/svg/logo.svg","width":"120"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }